const pfizerTips = [
    "请办会人自行联系餐厅进行预订",
    "请根据会议要求，合理选择餐厅距离",
    "建议使用平台餐厅用餐并结算，如使用非平台餐厅需要自行结算且将影响YES使用率考核，如对使用率考核有疑问请联系Yesprogram@pfizer.com",
]

export const addMealDemandTips = {
    pfizer: pfizerTips
}